module.exports = __webpack_public_path__ + "media/en_gb_s4_Parker.2c7bfa7d.oga";